import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQueryLargestDurationVarianceTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['largestDurationVarianceTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
